<template>
  <div class="page-heading header-text">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>About Us</h1>
          <span>We have over 20 years of experience</span>
        </div>
      </div>
    </div>
  </div>
  <div class="more-info about-info">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="more-info-content">
            <div class="row">
              <div class="col-md-6 align-self-center">
                <div class="right-content">
                  <span>our solid background on finance</span>
                  <h2>Get to know about <em>our company</em></h2>
                  <p>
                    DTECH- Tech Direct Solutions LLP a Business Consulting Company registered with SECP having its
                    directors coming from Telecoms Media & Technology. Together we bring in cumulative experience of
                    Telecoms & ICT sales, ICT Solution Sales, Fixed Network FTTH design, implementation Sales, Satellite
                    Solutions Broadcast & Digital Media. We consult with Telecoms & Media Regulatory bodies at CXO level
                    PTA & PEMRA.

                    <br><br>Working with Ministry of IT & Telecoms at Federal Government & relevant IT Boards at
                    Provincial
                    Domains. We provide 360 degree Business Consulting for those companies who wish to undertake
                    projects in
                    Public Sectors including Defense.
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="left-image">
                  <img src="../assets/about-image.jpg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="team">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-heading">
            <h2>Our team <em>members</em></h2>
            <span>Driving innovation and excellence with expertise and dedication</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="team-item">
            <img src="../assets/team_01.jpeg" alt="" />
            <div class="down-content">
              <h4>Qaisar Khan</h4>
              <span>Director & Co-founder</span>
              <p>
                He's a seasoned media executive with over two decades of experience in broadcasting and
                telecommunications. His
                distinguished career includes leadership roles at Max Media Private Limited, Pakistan Television
                Corporation Limited, and Leo Group, where he has pioneered key initiatives and driven strategic growth
                in Pakistan's media landscape.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="team-item">
            <img src="../assets/team_02.jpeg" alt="" />
            <div class="down-content">
              <h4>Syed Shahzad Hussain</h4>
              <span>CTO/Partner</span>
              <p>
                He boasts over three decades of comprehensive experience in telecom and ICT system integration, project
                management, and pre-sales/business development. His expertise spans operational management and strategic
                planning, highlighting a robust career in driving technology solutions and business growth.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="team-item">
            <img src="../assets/team_03.jpeg" alt="" />
            <div class="down-content">
              <h4>Imran Akhtar Shah</h4>
              <span>Chief Business Development Officer</span>
              <p>
                With over 33 years of experience, he excels in Strategy Development, Product Life Cycle Management, and
                Business Development within Telecommunications Media & Technologies. His career includes significant
                roles in ICT 360 Services. He has also served as a Board Member of the Universal Service Fund (USF) at
                the Ministry of IT and Telecoms, Government of Pakistan.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FunFactCard />
  <!-- <TestimonialCard /> -->
</template>

<script>
import FunFactCard from "@/components/FunFactCard.vue";

export default {
  name: "AboutView",
  components: {
    FunFactCard,
  },
};
</script>
<style>
.left-image img {
  height: 400px;
}
</style>